import React from "react";
import Toggle from "react-toggle";
import { connect } from "react-redux";
import * as dataActions from "../../../../../utils/data/dataActions";
import { change as changeFieldValue } from "redux-form";
import _ from "lodash";
import * as types from "../../../../../utils/data/dataActionTypes";
import userHasAccess from "../../../../../utils/userHasAccess";
import { FormattedMessage } from "react-intl";
import { ADMINISTRATOR, HR_CLERK, DIRECTOR, FINTECH, MANAGER } from "../../../../../utils/Roles";
import { BSModal } from "../../../../common";
import { PropTypes } from "react/lib/React";
import { MEMBERS } from "../../../../../utils/data/models";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../../enums/clientStatusTypes";

class SyncDeactivationButton extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            submitting: false,
            showModal: false,
            checked: null,
            modalMessage: null,
            buttonStateBeforeCall: false,
        };

        this.submit = this.submit.bind(this);
        this.handleToggleChange = this.handleToggleChange.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.updateIsSyncDisabled = _.debounce(this.updateIsSyncDisabled.bind(this), 350);
        this.canEditSyncButton = this.canEditSyncButton.bind(this);

        this.canEditButton = userHasAccess([MANAGER, DIRECTOR, FINTECH, ADMINISTRATOR], true);
        this.canEditButtonForImplementation = userHasAccess([DIRECTOR, FINTECH, ADMINISTRATOR], true);
    }

    componentWillMount() {
        const { member } = this.props;
        if (member) this.setState({ checked: member.isSyncDisabled });
    }

    canEditSyncButton() {
        const { activeClient } = this.props;
        if (!activeClient) return false;

        switch (activeClient.clientStatusType) {
            case IMPLEMENTATION.value:
                return this.canEditButtonForImplementation;
            case ACTIVE.value:
            case INACTIVE.value:
            case TERMINATED.value:
                return this.canEditButton;
        }
    }

    updateIsSyncDisabled(isSyncDisabled) {
        const { dataActions, member } = this.props;
        this.props.setSubmittingToggle(true);

        dataActions.updateDataItem(MEMBERS, { memberId: member.memberId, isSyncDisabled }).then((data) => {
            if (data.type === types.UPDATE_DATA_ITEM_FAILURE) {
                if (data.payload.error.data.error === "invalidDataType") {
                    toast(<FormattedMessage id="members.member.errors.invalidDataType" />, {
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast(<FormattedMessage id="genericSaveError" />, {
                        type: toast.TYPE.ERROR,
                    });
                }
            } else {
                const isSyncDisabled = data.payload.data.isSyncDisabled;
                this.setState({ checked: isSyncDisabled });
                this.props.changeFieldValue("memberForm", "isSyncDisabled", isSyncDisabled);

                this.props.dataActions
                    .getDataItem(MEMBERS, this.props.member.memberId, {
                        fields: "memberCoverages(memberCoverageGuarantees(*),*),*",
                    })
                    .then(() => {
                        toast(<FormattedMessage id="genericSaveSuccess" />, {
                            type: toast.TYPE.SUCCESS,
                        });

                        this.setState({ submitting: false });
                        this.props.setSubmittingToggle(false);
                    });
            }
        });
    }

    submit() {
        this.updateIsSyncDisabled(this.state.buttonStateBeforeCall);
        this.setState({ showModal: false });
    }

    handleToggleChange(e) {
        const modalMessage = e.target.checked
            ? "members.activateDisableSyncWarning"
            : "members.deactivateDisableSyncWarning";
        this.setState({
            submitting: true,
            showModal: true,
            modalMessage: modalMessage,
            buttonStateBeforeCall: e.target.checked,
        });
    }

    handleModalClose() {
        this.setState({ showModal: false, submitting: false });
    }

    render() {
        const { modalMessage, showModal } = this.state;
        const canEditButton = this.canEditSyncButton();
        return !userHasAccess(HR_CLERK, true) && (
            <div className="d-flex sync-toggle-container">
                <Toggle
                    disabled={!canEditButton || this.state.submitting}
                    checked={this.state.checked}
                    icons={{
                        checked: null,
                        unchecked: null,
                    }}
                    onChange={this.handleToggleChange}
                />
                <FormattedMessage id="members.disableSync" />
                {
                    showModal && modalMessage && (
                        <BSModal
                            show={showModal}
                            title={
                                <FormattedMessage id="validation.clientFieldValidation.attention">
                                    {(f) => <span className="icon warning">{f}</span>}
                                </FormattedMessage>
                            }
                            actions={[{ id: 1, text: <FormattedMessage id="common.confirm" />, action: this.submit }]}
                            onClose={this.handleModalClose}
                        >
                            <FormattedMessage id={modalMessage} values={{ br: <br /> }} />
                        </BSModal>
                    )
                }
            </div>
        );
    }
}

SyncDeactivationButton.propTypes = {
    member: PropTypes.object,
    dataActions: PropTypes.object,
    setSubmittingToggle: PropTypes.func,
    changeFieldValue: PropTypes.func,
    activeClient: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}

function mapStateToProps(state) {
    const { clients } = state.data;

    return {
        activeClient: clients.active,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SyncDeactivationButton);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/SyncDeactivationButton.js